export enum PlayerConflictMode {
    Normal = 'Normal',
    BindAction = 'BindAction',
    BindHotkey = 'BindHotkey',
}
